import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.anytimechildcare.london/api",
});

export default instance;
